// extracted by mini-css-extract-plugin
export var parcelRow = "_rl-0";